<template>
  <v-container fluid>
    <PageHeader title="Manage Units" icon="emoji_symbols" />
    <v-layout wrap>
      <v-flex xs6 pr-3>
        <unitDetailManage></unitDetailManage>
      </v-flex>
      <v-flex xs6 pl-3>
        <unitGroupManage></unitGroupManage>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import unitGroupManage from './UnitGroupManage'
  import unitDetailManage from './UnitDetailManage'
  import PageHeader from '@/components/generic/PageHeader'

  const unit = createNamespacedHelpers('unit')

  export default {
    components: {
      PageHeader,
      unitGroupManage,
      unitDetailManage,
    },
    data() {
      return {
        model: 'tab-1',
      }
    },
    computed: {
      ...unit.mapGetters(['allUnitGroups', 'allUnits', 'isLoadAllUnits', 'isLoadAllUnitGroups']),
    },
    mounted() {
      if (!this.allUnits || !this.allUnits.length) {
        if (!this.isLoadAllUnits) {
          this.changeLoadAllUnits()
          this.getUnitList().then(() => this.changeLoadAllUnits()).catch(() => this.changeLoadAllUnits())
        }
      }
      if (!this.allUnitGroups || !this.allUnitGroups.length) {
        if (!this.isLoadAllUnitGroups) {
          this.changeLoadAllUnitGroups()
          this.getUnitGroup().then(() => this.changeLoadAllUnitGroups()).catch(() => this.changeLoadAllUnitGroups())
        }
      }
    },
    methods: {
      ...unit.mapActions(['getUnitList', 'getUnitGroup', 'changeLoadAllUnits', 'changeLoadAllUnitGroups']),
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important
  }
</style>